<template>
  <i v-if="faClass" class="fas group-icon" :class="faClass" aria-hidden="true"></i>
  <i v-else class="material-icons group-icon" aria-hidden="true">{{ icon }}</i>
</template>

<script>
/**
 * Ícono de un grupo visual. El campo `icon` se carga a mano o lo siembran los
 * módulos, y llega con nombres de las dos librerías: Material usa `_`
 * (`attach_money`), FontAwesome usa `-` o el prefijo `fa-` (`file-invoice`,
 * `fa-info-circle`). Dibujar un nombre FA con la fuente Material sale como
 * texto roto y corre el título.
 */
export default {
  name: "GroupIcon",
  props: {
    icon: { type: String, default: "" },
  },
  computed: {
    faClass() {
      const name = String(this.icon || "").trim();
      if (!name) return "";
      if (/^fa[srlbd]?\s/.test(name)) return name.replace(/^fa[srlbd]?\s+/, "");
      if (name.startsWith("fa-")) return name;
      if (name.includes("-")) return "fa-" + name;
      return "";
    },
  },
};
</script>

<style>
/* Ancho fijo: un nombre que no es ligadura exacta (p. ej. `tasks` → `task` + «s»)
   no empuja el título. */
.group-icon.material-icons {
  width: 1em;
  overflow: hidden;
}
.group-icon.fas {
  width: 1em;
  text-align: center;
}
</style>
